import React from 'react';
import { useParkingWizardStore, ParkingWizardStep } from 'Stores/ParkingWizardStore';
import { ParkingLocationStep } from './Steps/ParkingLocationStep';
import { ParkingVehiclesStep } from './Steps/ParkingVehiclesStep';
import { ParkingReviewStep } from './Steps/ParkingReviewStep';
import { ParkingPaymentStep } from './Steps/ParkingPaymentStep';
import { ParkingProgressBar } from './ParkingProgressBar';
import { MessageBox } from 'Views/Components/_HumanWritten/MessageBox/MessageBox';

const STEPS: { key: ParkingWizardStep; label: string }[] = [
	{ key: 'location', label: 'Select Location' },
	{ key: 'vehicles', label: 'Add Vehicles' },
	{ key: 'review', label: 'Review & Quote' },
	{ key: 'payment', label: 'Payment' },
];

function getStepComponent(step: ParkingWizardStep): React.ReactNode {
	switch (step) {
		case 'location':
			return <ParkingLocationStep />;
		case 'vehicles':
			return <ParkingVehiclesStep />;
		case 'review':
			return <ParkingReviewStep />;
		case 'payment':
			return <ParkingPaymentStep />;
		default:
			return null;
	}
}

export function ParkingWizard() {
	const { step, error } = useParkingWizardStore();

	return (
		<div className="parking-wizard">
			<ParkingProgressBar steps={STEPS} currentStep={step} />
			{error && (
				<MessageBox status="error" className="parking-wizard__error">
					{error}
				</MessageBox>
			)}
			<div className="parking-wizard__content">{getStepComponent(step)}</div>
		</div>
	);
}
